/* this file is auto-generated.  DO NOT MODIFY*/
import BreakpointTool from '../../Components/BreakpointTool/scripts/BreakpointTool.js';
import Chatbot from '../../Components/Chatbot/scripts/Chatbot.js';
import ComponentA from '../../Components/ComponentA/scripts/ComponentA.js';
import GoogleMaps from '../../Components/GoogleMaps/scripts/GoogleMaps.js';
import InPageNavigation from '../../Components/InPageNavigation/scripts/InPageNavigation.js';
import MenuBuilder from '../../Components/MenuBuilder/scripts/MenuBuilder.js';
import Slider from '../../Components/Slider/scripts/Slider.js';
import Tabs from '../../Components/Tabs/scripts/Tabs.js';

export default [
		BreakpointTool,
		Chatbot,
		ComponentA,
		GoogleMaps,
		InPageNavigation,
		MenuBuilder,
		Slider,
		Tabs
	];

